import { Action, ActionReducer, INIT } from '@ngrx/store';

import * as actions from './settings.actions';
import { SettingsState } from './settings.reducer';

const html = document.querySelector('html');
const body = document.querySelector('body');

// meta tableSortReducer that applies layout classes based on settings tableSortReducer
export function settingsMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return (state: { settings: SettingsState }, action: Action) => {
        // build new state
        const result = reducer(state, action);

        // use our middleware only for INIT action and for Settings actions
        if (action.type === INIT || actions.SettingsActionTypes.includes(action.type)) {
            handleCssClasses(result.settings);
        }

        // pass state into next chain
        return result;
    };
}

function handleCssClasses(state: SettingsState): void {
    (window as any).handleClassCondition(state.fixedHeader, 'header-function-fixed', body);
    (window as any).handleClassCondition(state.fixedNavigation, 'nav-function-fixed', body);
    (window as any).handleClassCondition(state.topNavigation, 'nav-function-top', body);
    (window as any).handleClassCondition(state.globalFontSize === 'sm', 'root-text-sm', html);
    (window as any).handleClassCondition(state.globalFontSize === 'md', 'root-text', html);
    (window as any).handleClassCondition(state.globalFontSize === 'lg', 'root-text-lg', html);
    (window as any).handleClassCondition(state.globalFontSize === 'xl', 'root-text-xl', html);
}
